export default function restFormService(data) {
  const endpoint = "/api/form";

  return fetch(endpoint, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  })
    .then((response) => response)
    .catch((error) => console.error("Error:", error));
}
